<template>
  <div class="my-auto">
    <v-btn-toggle
      v-model="toggleButtons"
      v-for="button in buttons"
      :key="button.id"
      style="background-color: #eaf1f5"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="mx-1" @click="dispatchCsCost(button)">
            <v-btn id="btn-actions" :disabled="!(can(button.code) && !signed)">
              <v-icon
                color="#39537a"
                v-on="on"
                v-bind="attrs"
                small
                class="icons__"
              >
                {{ button.icon }}
              </v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ button.tooltip }}</span>
      </v-tooltip>
    </v-btn-toggle>

    <v-dialog
      v-model="showAction"
      max-width="570px"
      persistent
      @keydown.esc="cancel()"
    >
      <v-card
        max-width="568px"
        style="max-height: 500px; overflow-y: scroll; scrollbar-width: unset"
      >
        <v-card-title
          style="display: flex; justify-content: center; margin-bottom: 2px"
          >{{ $tc("rulesRegister.title") }}
        </v-card-title>
        <v-card-subtitle style="display: flex; justify-content: center"
          >{{ nameRule }}
        </v-card-subtitle>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >

        <v-form ref="form" v-model="valid" lazy-validation class="mx-4">
          <v-alert outlined type="warning" prominent border="left"
            >{{ alertType }}
          </v-alert>
          <div v-if="formType !== 7">
            <v-select
              dense
              v-if="formType == 1"
              :label="$tc('editRegistrations.concept')"
              :items="getConcepts"
              required
              :rules="rules"
              item-text="name"
              item-value="conceptId"
              outlined
              style="height: 70px"
              v-model="concept"
            />
            <v-select
              dense
              v-else
              :label="$tc('editRegistrations.concept')"
              :items="getConceptHours"
              required
              :rules="rules"
              item-text="name"
              item-value="conceptId"
              outlined
              style="height: 70px"
              v-model="concept"
            />
            <v-select
              dense
              :label="$tc('editRegistrations.csCosts')"
              required
              :rules="rules"
              :items="getCosts"
              item-text="name"
              item-value="id"
              outlined
              v-model="cost"
            />
            <div v-show="formType === 6 || formType === 8">
              <span style="color: grey">{{
                $tc("rulesRegister.entyAndExit")
              }}</span>
              <div class="slider__day">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-around;
                  "
                >
                  <v-checkbox
                    :label="$tc('autoriz.previousDay')"
                    v-model="yesterday"
                    :disabled="checkYesterday"
                    @change="changeYesterday"
                    style="margin-right: 10px"
                  />
                  <v-checkbox
                    :label="$tc('autoriz.laterDay')"
                    v-model="laterDay"
                    style="margin-right: 20px"
                    :disabled="checkLaterday"
                    @change="changeLaterday"
                  />
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-around;
                  "
                >
                  <date
                    :maxFrom="maxAct"
                    :minFrom="minAct"
                    v-if="!yesterday && !laterDay"
                  />
                  <date
                    :maxFrom="maxAnt"
                    :minFrom="minAnt"
                    :minTo="minToAnt"
                    :maxTo="maxToAnt"
                    v-if="yesterday"
                  />
                  <date
                    :maxTo="maxPos"
                    :minTo="minPos"
                    :maxFrom="maxFromPos"
                    :minFrom="minFromPos"
                    v-if="laterDay"
                  />
                </div>
              </div>
              <div
                class="sliderCantHs"
                style="margin-bottom: 30px; margin-top: 30px"
                v-show="formType === 8"
              >
                <v-slider
                  v-model="amountHours"
                  max="24"
                  thumb-label="always"
                  :label="$tc('rulesRegister.amountHours')"
                  class="mt-5 ml-2 slider"
                  thumb-size="20"
                />
              </div>
            </div>
          </div>
        </v-form>
        <div class="d-flex justify-space-between pb-4 mx-4">
          <v-btn class="bt-exit" @click="cancel()"
            >{{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn class="bt-acept" @click.prevent="validate"
            >{{ $tc("editRegistrations.acept") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import permissions from "../../../mixins/permissions";
import registrations from "@/store/gestionTiempos/registrations";
import resultSettlementHours from "@/store/gestionTiempos/resultSettlementHours";
import Date from "./Date.vue";
export default {
  props: {
    date: String,
  },
  components: { Date },
  mixins: [permissions],
  data() {
    return {
      maxAct: "23:59",
      minAct: "00:00",
      minAnt: "12:00",
      maxAnt: "23:59",
      minToAnt: "00:00",
      maxToAnt: "11:59",
      maxFromPos: "23:59",
      minFromPos: "12:00",
      maxPos: "11:59",
      minPos: "00:00",
      yesterday: false,
      laterDay: false,
      valid: true,
      alertError: false,
      alertOk: false,
      textAlert: "",
      alertValidate: "",
      amountHours: 0,
      toggleButtons: null,
      concept: null,
      cost: null,
      showAction: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      buttons: [
        {
          id: 1,
          tooltip: "Ausente",
          icon: "mdi-account-off",
          rule: "AUSENTE",
          code: "accion:reglasregisausen",
        },
        {
          id: 2,
          tooltip: "Tarde",
          icon: "mdi-av-timer",
          rule: "TARDE",
          code: "accion:reglasregistarde",
        },
        {
          id: 3,
          tooltip: "Retiro anticipado",
          icon: "mdi-exit-to-app",
          rule: "RETANT",
          code: "accion:reglasregisretiro",
        },
        {
          id: 4,
          tooltip: "Inconsistencia de entrada",
          icon: "mdi-clock-alert",
          rule: "INENT",
          code: "accion:reglasregisinent",
        },
        {
          id: 5,
          tooltip: "Inconsistencia de salida",
          icon: "mdi-clock-alert-outline",
          rule: "INSAL",
          code: "accion:reglasregisinsal",
        },
        {
          id: 6,
          tooltip: "Forzar",
          icon: "mdi-door-closed-lock",
          rule: "FORZAR",
          code: "accion:reglasregisforzar",
        },
        {
          id: 7,
          tooltip: "Juntar",
          icon: "mdi-door-sliding",
          rule: "JUNTAR",
          code: "accion:reglasregisjuntar",
        },
        {
          id: 8,
          tooltip: "Completar",
          icon: "mdi-file-check-outline",
          rule: "COMPLETAR",
          code: "accion:reglasregiscompletar",
        },
      ],
      formType: null,
      ruleItem: null,
      error: false,
      data: null,
      alertType: null,
      nameRule: null,
      fromValue: null,
      toValue: null,
      checkLaterday: false,
      checkYesterday: false,
    };
  },

  computed: {
    from: {
      get: function () {
        return registrations.state.dateFrom;
      },
      set: function (newDate) {
        return newDate;
      },
    },
    to: {
      get: function () {
        return registrations.state.dateTo;
      },
      set: function (newDate) {
        return newDate;
      },
    },
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getConcepts() {
      return registrations.state.concepts;
    },
    getCosts() {
      return registrations.state.csCosts;
    },
    getInfoRules() {
      return registrations.state.rules;
    },
    getConceptHours() {
      let conceptsHours = registrations.state.concepts.filter((element) => {
        return element.licTot === "N";
      });

      return conceptsHours;
    },
  },
  methods: {
    dispatchCsCost(item) {
      registrations.dispatch("getCsCost").then(() => {
        this.showAusens(item);
      });
    },
    showAusens(item) {
      let cost = registrations.state.csCosts;
      registrations.dispatch("getInfoRules").then((r) => {
        this.showAction = true;
        this.formType = item.id;
        this.ruleItem = item.rule;
        const tipo = registrations.state.rules.filter(
          (rule) => rule.initials == this.ruleItem
        );
        this.alertType = tipo[0].description;
        this.nameRule = tipo[0].rule;
        this.cost = registrations.state.csCosts.find((e) => e.id == 1);
      });
      registrations.dispatch("getConcepts");
    },
    changeLaterday(value) {
      if (value) {
        this.checkYesterday = true;
      } else {
        this.checkYesterday = false;
      }
    },
    changeYesterday(value) {
      if (value) {
        this.checkLaterday = true;
      } else {
        this.checkLaterday = false;
      }
    },

    validate() {
      let valid = this.$refs.form.validate();
      let cost = registrations.state.csCosts.filter((item) => {
        return item.id == this.cost;
      })[0];
      let concepts = registrations.state.concepts.filter((item) => {
        return item.conceptId == this.concept;
      })[0];
      if (this.formType === 8 || this.formType === 6) {
        this.fromValue = this.convertStringInMin(this.from);
        this.toValue = this.convertStringInMin(this.to);

        if (this.laterDay) {
          this.toValue += 1440;
        }
        if (this.yesterday) {
          this.fromValue = this.fromValue - 1440;
        }
      }

      if (valid) {
        if (this.formType === 1) {
          this.data = {
            concept: this.concept,
            csCost: this.cost.id,
            rule: this.ruleItem,
            date: this.date + "T00:00:00.000Z",
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };
          this.addRules();
        } else if (this.formType === 2) {
          this.data = {
            concept: this.concept,
            csCost: this.cost.id,
            rule: this.ruleItem,
            date: this.date + "T00:00:00.000Z",
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };
          this.addRules();
        } else if (this.formType === 3) {
          this.data = {
            concept: this.concept,
            csCost: this.cost.id,
            rule: this.ruleItem,
            date: this.date + "T00:00:00.000Z",
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };
          this.addRules();
        } else if (this.formType === 4) {
          this.data = {
            concept: this.concept,
            csCost: this.cost.id,
            rule: this.ruleItem,
            date: this.date + "T00:00:00.000Z",
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };
          this.addRules();
        } else if (this.formType === 5) {
          this.data = {
            concept: this.concept,
            csCost: this.cost.id,
            rule: this.ruleItem,
            date: this.date + "T00:00:00.000Z",
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };
          this.addRules();
        } else if (this.formType === 6) {
          this.data = {
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };

          this.validateHours();
        } else if (this.formType === 7) {
          this.data = {
            rule: this.ruleItem,
            date: this.date + "T00:00:00.000Z",
          };
          this.addRules();
        } else if (this.formType === 8) {
          this.data = {
            conceptName: concepts.name.trim(),
            costName: this.cost.name.trim(),
          };
          this.validateHours();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    addRules() {
      registrations.commit("setNewRule", this.data);
      registrations
        .dispatch("newRule")
        .then((e) => {
          this.textAlert = e.data.strError;
          this.alertOk = true;
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
        })
        .catch((e) => {
          this.textAlert = "No se pudo crear la nueva regla";
          this.alertError = true;
        });
      registrations.dispatch("getCsCost");
      this.cancel();
    },
    validateHours() {
      if (this.fromValue > this.toValue) {
        this.error = true;
        this.alertValidate = this.$tc("autoriz.greater");
        setTimeout(() => {
          this.error = false;
        }, 3000);
      } else if (this.toValue > 2160) {
        this.error = true;
        this.alertValidate = "No puede superar las 12:00 am del dia posterior";
        setTimeout(() => {
          this.error = false;
        }, 3000);
      } else if (this.fromValue < -720) {
        this.error = true;
        this.alertValidate = "No puede superar las 12:00 am del dia anterior";
        setTimeout(() => {
          this.error = false;
        }, 3000);
      } else {
        this.addItemsWithSliderHours();
      }
    },
    addItemsWithSliderHours() {
      if (this.formType === 8) {
        this.data = {
          conceptName: this.data.conceptName,
          costName: this.data.costName,
          concept: this.concept,
          csCost: this.cost.id,
          rule: this.ruleItem,
          date: this.date + "T00:00:00.000Z",
          from: this.fromValue,
          to: this.toValue,
          amountHours: this.amountHours * 60,
        };
      } else if (this.formType === 6) {
        this.data = {
          concept: this.concept,
          csCost: this.cost.id,
          rule: this.ruleItem,
          date: this.date + "T00:00:00.000Z",
          from: this.fromValue,
          to: this.toValue,
        };
      }
      this.addRules();
    },
    cancel() {
      registrations.commit("setDateTo", "12:00");
      registrations.commit("setDateFrom", "06:00");
      let cost = registrations.state.csCosts;
      this.showAction = false;
      this.error = false;
      this.$refs.form.resetValidation();
      this.from = registrations.state.dateFrom;
      this.to = registrations.state.dateTo;
      this.concept = null;
      this.laterDay = false;
      this.yesterday = false;
      this.cost = cost[0]?.id;
    },

    convertStringInMin(value) {
      let hour = parseInt(value.slice(0, 2), 10);
      let min = parseInt(value.slice(-2), 10);

      let minTotal = hour * 60 + min;
      return minTotal;
    },
  },
};
</script>
<style scoped>
input[type="time"]::-webkit-calendar-picker-indicator {
  background: #90afde !important;
  /* background: url(../../../../assets/clock.png) no-repeat !important; */
  cursor: pointer !important;
}
.bt-exit {
  width: 100px;
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  width: 100px;
  background-color: #77dd77 !important;
  color: white !important;
}

@media (min-width: 300px) and (max-width: 850px) {
  .icons__ {
    font-size: 1.2em !important;
    cursor: pointer !important;
  }
}

.btns {
  display: grid !important;
  cursor: pointer !important;
}

.slider__day {
  border: 1px solid #959595;
  border-radius: 5px;
  height: 133px;
}

.sliderCantHs {
  border: 1px solid #959595;
  border-radius: 5px;
  height: 68px;
}

.line__zeroplus {
  border-left: thick solid #a8a8a8 !important;
  height: 1.5% !important;
  left: 50% !important;
  border-radius: 5px !important;
  position: absolute !important;
  margin-top: 15px !important;
  margin-left: 129px !important;
}

.line__zero {
  border-left: thick solid #a8a8a8 !important;
  border-radius: 5px !important;
  height: 1.5% !important;
  left: 50% !important;
  position: absolute !important;
  margin-top: 15px !important;
  margin-left: -132px !important;
}
#btn-actions {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #39537a !important;
  background-color: #ffffff;
}
.v-btn:not(.v-btn--round).v-size--default {
  min-width: 0px !important;
  padding: 0px !important;
}
#btn-actions:hover {
  background-color: #39537a !important;
  color: white !important;
}
.icons__:hover {
  color: #ffffff !important;
}
</style>
